import React from "react";
import { Flex, Box, Text, Grid, GridItem, Wrap, WrapItem, Image, Link } from "@chakra-ui/react";
import { FaFacebook, FaTwitter } from "react-icons/fa";
import { AiFillInstagram, AiFillLinkedin } from "react-icons/ai";
import youtubeLogo from "../../Images/footer/youtube.svg";

import style from "./Footer.module.css";
import androidDownload from "../../Images/footer/googlePlayStore.svg";
import iosDownload from "../../Images/footer/iosDownload.svg";
import useCustomNavigate from "../../hooks/useCustomNavigate";
import useScrollToTop from "../../hooks/useScrollToTop";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

function FooterOptions() {
    const { goTo, goToNewTab } = useCustomNavigate();
    const scrollToTop = useScrollToTop();
    const location = useLocation();
    const isHome = location.pathname === "/";

    const locationDetails = useSelector((state) => state.counter.location);
    const city = locationDetails?.city || "New Delhi"; // Default city if not available
    console.log("locationDetails", locationDetails, city)


    // Function to encode the location details as a query string
    const encodeLocationDetails = () => {
        const locationData = {
            city: locationDetails.city || '',
            state: locationDetails.state || '',
            country: locationDetails.country || ''
        };
        return encodeURIComponent(JSON.stringify(locationData)); // Encoding the location object
    };


    return (
        <Box p={{ base: "20px", md: "40px" }}
            bg={isHome ? "transparent" : "#f5f5f5"}
            color={isHome ? "white" : "black"}

        >
            <Text fontSize="22px" fontWeight="600" pb="15px">121 Services</Text>

            <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={8}>
                {/* Buy Section */}
                <GridItem>
                    <Text fontSize="17px" fontWeight="600" >Buy</Text>
                    <Wrap spacing={3} py="15px">
                        {["Home Loan", "Property Legal Services", "Interiors", "Sale Agreement", "121 For NRI's", "New Builder Project", "EMI Calculator", "Home Loan Eligibility Check", "Apply Home Loan", "Buy / Sell Property Questions"].map((item) => (
                            <WrapItem key={item}
                                onClick={() => {
                                    if (item == "EMI Calculator") {

                                        goTo("/emi-calculator")
                                    }
                                }}
                            >{item}</WrapItem>
                        ))}
                    </Wrap>
                </GridItem>

                {/* Rent Section */}
                <GridItem>
                    <Text fontSize="17px" fontWeight="600" >Rent</Text>
                    <Wrap spacing={3} py="15px">
                        {["Rental Agreement", "Pay Rent", "Home Services", "Packers and Movers", "Property Management in India", "Rent Services Questions"].map((item) => (
                            <WrapItem key={item}>{item}</WrapItem>
                        ))}
                    </Wrap>
                </GridItem>
            </Grid>

            {/* Find Property & List Property Section */}
            <Flex
                className={style.findNow}
                flexDirection={{ base: "column", md: "row" }}
                mt="30px"
                border="1px solid grey"
                borderRadius="8px"
                overflow="hidden"
                color={"black"}
            >
                <Box w={{ base: "100%", md: "50%" }} p="20px" textAlign="center" borderRight={{ md: "1px solid grey" }}>
                    <Text as="b" fontSize="18px">Find Property</Text>
                    <Text fontSize="14px" mt="5px">Select from thousands of options, without brokerage.</Text>
                    <Box
                        as="button"
                        backgroundColor="#464646"
                        color="white"
                        p="10px 20px"
                        mt="10px"
                        borderRadius="5px"

                        onClick={() => {
                            // Encode the location details and append it to the URL query string
                            const locationQuery = encodeLocationDetails();
                            const parentQuery = `&parentCategory=Sell`

                            goToNewTab(`/searchresult/bycategory?location=${locationQuery}${parentQuery}`);

                        }}
                    >Find Now</Box>
                </Box>

                <Box w={{ base: "100%", md: "50%" }} p="20px" textAlign="center">
                    <Text as="b" fontSize="18px">List Your Property</Text>
                    <Text fontSize="14px" mt="5px">For Free. Without any brokerage.</Text>
                    <Box as="button" backgroundColor="#464646" color="white" p="10px 20px" mt="10px" borderRadius="5px" onClick={() => goTo("/addproperty")}>Free Posting</Box>
                </Box>
            </Flex>

            {/* About Us Links */}
            <Flex wrap="wrap" justify="center" gap="10px" mt="30px" fontSize="14px" >
                {["About Us", "Careers", "Terms & Conditions", "Privacy Policy", "Testimonials", "Sitemap", "FAQs"].map((item) => (
                    <Text
                        key={item}
                        _hover={{ textDecoration: "underline" }}
                        cursor="pointer"

                        onClick={() => {
                            if (item == "About Us") {

                                goTo("/about-us")
                            }
                        }}
                    >
                        {item}
                    </Text>
                ))}
            </Flex>

            <Box border="1px solid rgba(70, 70, 70, .2)" my="35px" mx="auto" w="80%" />

            {/* App Download Links */}
            <Flex gap={5} justify="center" wrap="wrap">
                <Link href="#" isExternal>
                    <Image src={androidDownload} alt="Download Android App" />
                </Link>
                <Link href="#" isExternal>
                    <Image src={iosDownload} alt="Download iOS App" />
                </Link>
            </Flex>

            {/* Social Media Links */}
            <Flex gap={4} justify="center" wrap="wrap" mt="20px">
                {[{ icon: FaFacebook, link: "#" }, { icon: FaTwitter, link: "#" }, { icon: AiFillInstagram, link: "#" }, { icon: AiFillLinkedin, link: "#" }].map(({ icon: Icon, link }, index) => (
                    <Link key={index} href={link} isExternal fontSize="20px">
                        <Icon />
                    </Link>
                ))}
                <Link href="#" isExternal>
                    <Image src={youtubeLogo} alt="YouTube" boxSize="24px" />
                </Link>
            </Flex>

            <Text textAlign="center" fontSize="13px" letterSpacing="0.5px" mt="20px" >
                © 2013-22 121 Properties Solution Pvt. Ltd.
            </Text>
        </Box>
    );
}

export default FooterOptions;
